import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  rootAppBreadcrumbs: {
    marginBottom: 16,
    "& .break-top": {
      whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden",
      height: 24,
    },
    "& .link": {
      color: '#fff !important',

      "&:hover": {
        cursor: "pointer"
      },
    },

    "& .immerse-breadcrumbs":{
      color: '#fff !important'
    }
  },
}));
